// @ts-expect-error module not typed
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { getAgentTypeFromAudit, getAgentIdFromAudit, getAssignedAgentId, getAssignedAgentType
// @ts-expect-error module not typed
} from 'conversations-message-history/assignment-update-message/operators/assignmentGetters';
import { agentTypeToSenderType } from 'conversations-message-history/senders/operators/agentTypeToSenderType';
import { findSender } from 'conversations-message-history/senders/operators/findSender';
import { getData } from 'conversations-message-history/senders/operators/getters';
import AssignmentLabel from './AssignmentLabel';
import SystemMessage from '../system-message/SystemMessage';
// @ts-expect-error module not typed
import { isSenderLoading } from 'conversations-message-history/senders/operators/isSenderLoading';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { RotateLeadsIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const AssignmentSystemMessage = ({
  userId,
  message,
  senders,
  ungatedForThreadMessagesUIImprovements
}) => {
  const assignorId = getAgentIdFromAudit(message);
  const assignorType = agentTypeToSenderType(getAgentTypeFromAudit(message));
  const assigneeId = getAssignedAgentId(message);
  const assigneeType = agentTypeToSenderType(getAssignedAgentType(message));
  const assignorAsyncSender = findSender(assignorId, assignorType, senders);
  const assigneeAsyncSender = findSender(assigneeId, assigneeType, senders);
  const timestamp = getTimestamp(message);
  const isLoading = isSenderLoading(assignorAsyncSender) || isSenderLoading(assigneeAsyncSender);
  return /*#__PURE__*/_jsx(SystemMessage, {
    "data-test-id": "assignment-message",
    timestamp: timestamp,
    description: /*#__PURE__*/_jsx(AssignmentLabel, {
      activeAgentId: `${userId}`,
      assignorSender: assignorAsyncSender && getData(assignorAsyncSender),
      assigneeSender: assigneeAsyncSender && getData(assigneeAsyncSender),
      isLoading: isLoading
    }),
    icon: /*#__PURE__*/_jsx(IconCircle, {
      borderWidth: "0",
      icon: RotateLeadsIcon,
      size: "600"
    }),
    ungatedForThreadMessagesUIImprovements: ungatedForThreadMessagesUIImprovements
  });
};
AssignmentSystemMessage.displayName = 'AssignmentSystemMessage';
export default AssignmentSystemMessage;